// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v5.5.1-jSoAt0XH0RmA5q5lMsh2/mode=imports,min/optimized/keen-slider.js'

class CompleteLookCarousel extends window.BAO.CustomElement() {
  static get requiredExternalElements () {
    return ['next', 'previous']
  }

  connectedCallback () {
    super.connectedCallback()

    if (this.els.slide.elements.length < 2) return

    this.setAttribute(`data-initialised`, true)

    this.carousel = this.initialiseCarousel()
  }

  setupListeners () {
    super.setupListeners()
  }

  initialiseCarousel () {
    return new KeenSlider(this.els.slides.element, {
      duration: 1000,
      loop: false,
      mode: 'snap',
      slidesPerView: 2.25,
      slides: '.car-Carousel_Slide',
      spacing: 10,
      breakpoints: {
        '(min-width: 767px)': {
          spacing: 10,
          slidesPerView: 3.25,
        },
        '(min-width: 900px)': {
          spacing: 20,
          slidesPerView: 3.25,
        },
      },
      slideChanged: instance => {
        if (this.nextEl) {
          const currentSlide = instance.details().absoluteSlide
          const slidesPerView = instance.details().slidesPerView
          const carouselSize = instance.details().size

          currentSlide === 0
            ? this.previousEl.setAttribute('disabled', null)
            : this.previousEl.removeAttribute('disabled')

          currentSlide + slidesPerView >= carouselSize
            ? this.nextEl.setAttribute('disabled', null)
            : this.nextEl.removeAttribute('disabled')
        }
      },
      created: instance => {
        this.setAttribute(`data-initialised`, true)

        if (this.nextEl) {
          this.nextEl.addEventListener('click', () => {
            instance.next()
          })
        }

        if (this.previousEl) {
          this.previousEl.addEventListener('click', () => {
            instance.prev()
          })
        }

        if (this.previousEl) {
          this.previousEl.setAttribute('disabled', null)
        }
      },
    })
  }

  get nextEl () {
    return this.externalEls.next && this.externalEls.next.element
      ? this.externalEls.next.element
      : null
  }

  get previousEl () {
    return this.externalEls.previous && this.externalEls.previous.element
      ? this.externalEls.previous.element
      : null
  }
}

if (!customElements.get('complete-look-carousel')) {
  customElements.define('complete-look-carousel', CompleteLookCarousel)
}
